// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageGallery from 'react-image-gallery';
import ModalImage from "react-modal-image";

// set main bar color
const mainBarColor = "#ffaa54";

// import modules
import DefaultContainer from '../../modules/Containers/DefaultContainer';

// define main images
import ImgOut from '../../assets/pickupwinder-manual/article-out.jpg';
import ImgIn from '../../assets/pickupwinder-manual/article-in.jpg';

// define gallery
import ImgArticle1 from '../../assets/pickupwinder-manual/article-img1.jpg';
import ImgArticle1t from '../../assets/pickupwinder-manual/article-img1t.jpg';
const imgArticle1Text = "Radio France Fuzz pedal";
import ImgArticle2 from '../../assets/pickupwinder-manual/article-img2.jpg';
import ImgArticle2t from '../../assets/pickupwinder-manual/article-img2t.jpg';
const imgArticle2Text = "Radio France Fuzz pedal";
import ImgArticle3 from '../../assets/pickupwinder-manual/article-img3.jpg';
import ImgArticle3t from '../../assets/pickupwinder-manual/article-img3t.jpg';
const imgArticle3Text = "Radio France Fuzz pedal";
const gallery = [
    {
        original: ImgArticle1,
        thumbnail: ImgArticle1t,
        originalAlt: imgArticle1Text,
        thumbnailAlt: imgArticle1Text,
        originalTitle: imgArticle1Text,
        thumbnailTitle: imgArticle1Text
    },
    {
        original: ImgArticle2,
        thumbnail: ImgArticle2t,
        originalAlt: imgArticle2Text,
        thumbnailAlt: imgArticle2Text,
        originalTitle: imgArticle2Text,
        thumbnailTitle: imgArticle2Text
    },
    {
        original: ImgArticle3,
        thumbnail: ImgArticle3t,
        originalAlt: imgArticle3Text,
        thumbnailAlt: imgArticle3Text,
        originalTitle: imgArticle3Text,
        thumbnailTitle: imgArticle3Text
    },
];

// define youtube video
const YouTubeVideo = "https://www.youtube.com/embed/nCXyWrRzTU0";

// define image schematics
import ImgSchematic from '../../assets/pickupwinder-manual/article-schematic.jpg';

// define image cart
import ImgCart from '../../assets/shopping-cart.png';

export default function PagePickupWinderManual() {
    const { t } = useTranslation('pickupwindermanual', { keyPrefix: 'pickupwindermanual' });

    return (
        <>
            <div className="full-height-width">
                <div className="sticky-center-background" style={{ backgroundImage: `url(${ImgOut})` }} />
            </div>
            <div className="strip-title-container strip-title-containers1" style={{ color: mainBarColor }}>
                <div className="horizontal-vertical-center">
                    {t('title')}
                </div>
            </div>
            <div className="full-height-width">
                <div className="sticky-center-background" style={{ backgroundImage: `url(${ImgIn})` }} />
            </div>
            <div className="strip-posttitle-container strip-posttitle-containers1" style={{ backgroundColor: mainBarColor }}>
                <div className="horizontal-vertical-center">
                    {t('claim')}
                </div>
            </div>
            <div className="strip-content">
                <DefaultContainer>
                    <div dangerouslySetInnerHTML={{ __html: t('content', { interpolation: { escapeValue: false } }) }} />
                    <hr />
                    <div dangerouslySetInnerHTML={{ __html: t('samples', { interpolation: { escapeValue: false } }) }} />
                    <div className="samples-box">
                        <div className="responsive-iframe-container">
                            <iframe
                                width="560" height="315" className="responsive-iframe" src={YouTubeVideo} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>
                    </div>
                    <div className="shop-container">
                        <img src={ImgCart} />
                        <div dangerouslySetInnerHTML={{ __html: t('shop', { interpolation: { escapeValue: false } }) }} />
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: t('pictures', { interpolation: { escapeValue: false } }) }} />
                    <center>
                        <div className="pictures-box">
                            <ImageGallery items={gallery} thumbnailPosition="bottom" showPlayButton={false} />
                        </div>
                    </center>
                    <hr />
                    <div dangerouslySetInnerHTML={{ __html: t('open', { interpolation: { escapeValue: false } }) }} />
                    <center>
                        <div className="open-box">
                            <ModalImage
                                small={ImgSchematic}
                                large={ImgSchematic}
                            />
                        </div>
                    </center>
                </DefaultContainer>
            </div>
        </>);

}
